/**
 * Created by tschenkel on 8/31/2015.
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { LiveBranchingLiveEnvironment } from "./LiveBranchingLiveEnvironment";

export class LiveBranchingTestEnvironment extends LiveBranchingLiveEnvironment {
    public static LIVE_BRANCHING_TEST_ENVIRONMENT_ID: string = "LiveBranchingTestEnvironment";

    constructor() {
        super(LiveBranchingTestEnvironment.LIVE_BRANCHING_TEST_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();

        this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-netconf-test/{gameId}/{networkId}.xml";
        this._countryConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/country/{gameId}/{countryVersion}/country.xml";
        this._languageConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/language/{gameId}/{languageVersion}/{languageCode}.{zipSuffix}";

        this._cldrConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/language/{gameId}/cldr";

        this._accountCookiePathPattern = BasicConstants.DOMAIN_PROTOCOL + "://account.{domain}/CookieSaver.swf";

        this._versionPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/version/{gameId}/version.json";

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://" + BasicConstants.DOMAIN_INTERNAL_DNS + "/web/Web_PreClient/branches-test/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://" + BasicConstants.DOMAIN_INTERNAL_DNS + "/web/Web_PreClient/branches-test/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";

        this._refCountURLPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/loader-test/refcount.php";

        this._shopPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://shop-test.goodgamestudios.com/{languageCode}/";
    }

    public isSupported(): boolean {
        return this._data.globals.isLiveBranchingEnvironment && this._data.globals.isTest;
    }
}
